import React from 'react';

const MetaphiIcon = () => {
  return (
    <svg
      className="c-MetaphiIcon"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_340_112958)">
        <path
          fill="#AAA"
          d="M6.534 3.02a4.066 4.066 0 00-1.444.45 4 4 0 00-2.072 3.087C3.002 6.71 3 7.352 3 12.008c0 4.59.002 5.3.018 5.44a3.977 3.977 0 001.754 2.888 3.976 3.976 0 001.785.646c.153.016.795.018 5.451.018 4.59 0 5.3-.002 5.44-.018a3.977 3.977 0 002.888-1.754 3.976 3.976 0 00.646-1.785c.016-.153.018-.795.018-5.451 0-4.59-.002-5.3-.018-5.44a3.977 3.977 0 00-1.754-2.888 3.976 3.976 0 00-1.785-.646c-.153-.016-.792-.018-5.47-.017-4.394.001-5.319.005-5.439.018zm2.731 4.389c.046.015.202.105 1.528.88.468.273.88.512.919.531a.729.729 0 00.605.013c.027-.012.567-.333 1.201-.715.688-.414 1.176-.7 1.212-.712.122-.036.085-.055 1.348.67a64.46 64.46 0 011.154.67c0 .006-3.672 2.133-5.052 2.928l-.152.086-2.07-1.168C8.822 9.95 7.633 9.28 7.319 9.101a20.25 20.25 0 01-.574-.329c0-.006 2.17-1.28 2.279-1.337a.302.302 0 01.242-.026zm8.183 4.66c0 3.3.007 3.028-.083 3.12-.029.03-.44.274-1.187.706l-1.14.663-.006-1.065c-.003-1.175 0-1.107-.081-1.27a.771.771 0 00-.419-.352.891.891 0 00-.402-.012c-.095.026-.144.054-1.032.565l-.848.488c-.006.003-.01-.626-.01-1.396v-1.403l2.596-1.501a494.019 494.019 0 012.604-1.503c.004-.001.008 1.332.008 2.96zM7.062 9.43c.264.15.49.277.504.284l2.14 1.207 2.114 1.193V14.917l-.026-.014-.94-.537c-.54-.31-.946-.534-.994-.55a.718.718 0 00-.548.04.805.805 0 00-.316.311c-.082.16-.08.12-.08 1.312 0 1.015-.001 1.071-.02 1.063-.012-.004-.521-.3-1.132-.658-.71-.414-1.126-.664-1.153-.693-.09-.093-.083.177-.083-3.11v-2.95l.028.014.506.285zm2.69 4.783a100.24 100.24 0 011.852 1.063c0 .003-.512.295-1.138.647l-1.136.638-.004-1.051c0-.695.002-1.067.01-1.098a.343.343 0 01.233-.216.357.357 0 01.183.017zm4.714.079c.072.04.13.12.149.205.017.077.019 2.052.002 2.052-.008 0-1.649-.956-2.07-1.206-.104-.064-.105-.064-.078-.082a92.18 92.18 0 011.757-1 .33.33 0 01.24.03z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_340_112958">
          <path fill="#fff" d="M0 0H18V18H0z" transform="translate(3 3)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default MetaphiIcon;
